module.exports = __webpack_public_path__ + "img/Logo-WordProof-720-300x62.cf36537c.png";